import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { SocketProvider } from './contexts/SocketContext';
import { SidebarProvider } from './contexts/SidebarContext';

// Pages
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import MyApps from './pages/MyApps';
import MyApplications from './pages/MyApplications';
import Messages from './pages/Messages';
import Profile from './pages/Profile';
import AppDetail from './pages/AppDetail';
import CreateApp from './pages/CreateApp';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AuthCallback from './pages/AuthCallback';

// Components
import Navbar from './components/Navbar';
import ProtectedRoute from './components/ProtectedRoute';
import ProfileComponent from './components/ProfileComponent';

function AppRoutes() {
  const { user } = useAuth();
  const location = useLocation();
  const hideNavbarOn = ['/reset-password', '/forgot-password'];
  const shouldShowNavbar = user && !hideNavbarOn.includes(location.pathname);

  return (
      <div className="min-h-screen bg-gray-50">
        {shouldShowNavbar && <Navbar />}
        <main className={shouldShowNavbar ? "pt-16 md:pt-0" : ""}>
          <Routes>
            <Route path="/" element={user ? <Navigate to="/dashboard" /> : <Home />} />
            <Route path="/login" element={user ? <Navigate to="/dashboard" /> : <Login />} />
            <Route path="/register" element={user ? <Navigate to="/dashboard" /> : <Register />} />
            <Route path="/forgot-password" element={user ? <Navigate to="/dashboard" /> : <ForgotPassword />} />
            {/* Şifre sıfırlama ve auth callback sayfaları, kullanıcı oturumu olsa bile erişilebilir olmalı */}
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            
            <Route path="/my-apps" element={
              <ProtectedRoute>
                <MyApps />
              </ProtectedRoute>
            } />
            
            <Route path="/my-applications" element={
              <ProtectedRoute>
                <MyApplications />
              </ProtectedRoute>
            } />
            
            <Route path="/messages" element={
              <ProtectedRoute>
                <Messages />
              </ProtectedRoute>
            } />
            
            <Route path="/profile" element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            } />
            
            <Route path="/profile/:userId" element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            } />
            
            <Route path="/app/:id" element={
              <ProtectedRoute>
                <AppDetail />
              </ProtectedRoute>
            } />
            
            <Route path="/create-app" element={
              <ProtectedRoute>
                <CreateApp />
              </ProtectedRoute>
            } />
          </Routes>
        </main>
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
          }}
        />
      </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <SocketProvider>
        <SidebarProvider>
          <Router>
            <AppRoutes />
          </Router>
        </SidebarProvider>
      </SocketProvider>
    </AuthProvider>
  );
}

export default App;